import axios from 'axios';

// eslint-disable-next-line import/no-cycle
import { store } from '~/store';
import { signOut } from '~/store/modules/auth/actions';

const api = axios.create({
  baseURL: sessionStorage.getItem('URL_BACKEND')
    ? sessionStorage.getItem('URL_BACKEND')
    : '/',
});

// Add a response interceptor
api.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    const { data, status } = error.response;

    if (status === 403 || status === 401) {
      store.dispatch(signOut());

      const erros = ['você não tem permissão de acesso nesse servidor'];

      return Promise.reject(erros);
    }

    if (data && data.erros) {
      const { erros } = data;

      return Promise.reject(erros);
    }

    const erros = [error.message];

    return Promise.reject(erros);
  }
);

export default api;
